<template>
<div id="greeter">
  <div id="full-logo"></div>
  <div class="title" v-html="content.title.toUpperCase()"></div>
  <div class="subtitle" v-html="content.content.toUpperCase()"></div>
</div>
</template>

<script>
export default {
  name: 'Greeter',
  props: { content: Object },
};
</script>

<style scoped lang="scss">
  #greeter {
    $height: 270px;

    position: absolute;
    width: 100%;
    height: $height;
    top: calc(50vh - calc(#{$height} / 2));
    padding: 25px;

    display: flex; flex-direction: column;
    justify-content: center; align-items: center;

    @media (min-width: 768px) {
      $height: 285px;
      $width: 650px;
      height: $height; top: calc(50vh - calc(#{$height} / 2));
      width: $width; left: calc(50% - calc(#{$width} / 2));
    }

    @media (min-width: 992px) {
      $height: 317px;
      $width: 700px;
      height: $height; top: calc(50vh - calc(#{$height} / 2));
      width: $width; left: calc(50% - calc(#{$width} / 2));
    }

    @media (min-width: 1200px) {
      $height: 372px;
      $width: 1000px;
      height: $height; top: calc(50vh - calc(#{$height} / 2));
      width: $width; left: calc(50% - calc(#{$width} / 2));
    }
  }

  .title, .subtitle {
    text-align: center;
    font-family: 'Josefin Sans', sans-serif;
    font-weight: bold;
  }

  .title {
    font-size: 3em;
    color: #f3ff18;

    @media (min-width: 768px) { font-size: 3.2em; }
    @media (min-width: 992px) { font-size: 3.5em; }
    @media (min-width: 1200px) { font-size: 5em; }
  }

  .subtitle {
    font-size: 0.88em;
    line-height: 19px;
    color: white;

    @media (min-width: 768px) { font-size: 0.92em; }
    @media (min-width: 992px) { font-size: 1.02em; }
    @media (min-width: 1200px) { font-size: 1.11em; }
  }

  #full-logo {
    $logo-width: 886px;
    $logo-height: 224px;
    $scale: 0.5;

    display: none;
    position: relative;
    top: -40px;


    @media (min-width: 768px) {
      $scale: 0.6;

      display: block;

      background-image: url("../../assets/logos/logo-transparent.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;

      width: calc(#{$scale} * #{$logo-width});
      height: calc(#{$scale} * #{$logo-height});
    }

    @media (min-width: 992px) {
      $scale: 0.7;

      width: calc(#{$scale} * #{$logo-width});
      height: calc(#{$scale} * #{$logo-height});
    }

    @media (min-width: 1200px) {
      $scale: 0.9;

      width: calc(#{$scale} * #{$logo-width});
      height: calc(#{$scale} * #{$logo-height});
    }
  }
</style>
